export default __webpack_public_path__ + "static/media/GE.6f722c0c.png";